import styled from "@emotion/styled";
import { Heading, Button, Text } from "nectar-ui";
import { NectarTheme } from "@nectarTypes";
import { css } from "@emotion/core";

// TEMPORARY: declaration types should be added to nectar-ui
export const SupportContainer = styled.div<NectarTheme>`
  ${({ theme }) => `margin-top: ${theme.spacings.lg};`}
`;

export const HomeHeadingContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    margin: ${theme.spacings.lg} 0px;
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    width: 80%;
    align-items: center;
    text-align: center;

    ${theme.spacings.sm} {
      width: 290px;
    }
  `}
`;
export const HomePageContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ${theme.spacings.lg};
    background-color: ${theme.colors.white};
    position: relative;
  `}
`;

export const ClientHeading = styled(Heading)`
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 4px;
`;

export const CustomButton = styled(Button)<NectarTheme & { options: { hideOnMobile: boolean } }>`
  ${({ theme, options }) => css`
    & > span {
      display: flex;
      align-items: center;
      column-gap: ${theme.spacings.xs};
    }

    ${options?.hideOnMobile &&
    css`
      display: none;

      ${theme.breakpoints.md} {
        display: block;
      }
    `}
  `}
`;

export const HomeSubText = styled(Text)`
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 140%;
`;

export const LogoutButtonContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    margin-top: ${theme.spacings.xl};
    margin-bottom: ${theme.spacings.xl};
    display: flex;
    width: 290px;

    ${theme.breakpoints.sm} {
      width: 170px;
    }
  `}
`;
